import firebase from "firebase/app"
import "firebase/auth"
import "firebase/firestore"

export async function apiRequest() {
  await firebase.auth().signOut()
}
